import { Observable, of } from 'rxjs';

import { HomeCarouselSlidesData } from '@/data/home-carousel.data';
import { HomeCarouselSlide } from '@/views/Home/home-carousel.model';

export const getHomeCarouselSlides = (): Observable<HomeCarouselSlide[]> =>
    of(HomeCarouselSlidesData);
